import { render, staticRenderFns } from "./ValanceGroup.vue?vue&type=template&id=61b68caa&scoped=true&"
import script from "./ValanceGroup.vue?vue&type=script&lang=ts&"
export * from "./ValanceGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ValanceGroup.vue?vue&type=style&index=0&id=61b68caa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b68caa",
  null
  
)

export default component.exports